import { render, staticRenderFns } from "./Classe.vue?vue&type=template&id=3cbcf936&scoped=true"
import script from "./Classe.vue?vue&type=script&lang=js"
export * from "./Classe.vue?vue&type=script&lang=js"
import style0 from "./Classe.vue?vue&type=style&index=0&id=3cbcf936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbcf936",
  null
  
)

export default component.exports